export enum ENUM_PERMISSIONS {
  READ_NOTIFICATION = 'READ_NOTIFICATION',
  DELETE_NOTIFICATION = 'DELETE_NOTIFICATION',
  // PRED-3171: Carrousel d'actualités
  READ_ACTIVITY_CARROUSEL = 'READ_ACTIVITY_CARROUSEL',
  // PRED-3128 : Tableau de bord → Indicateurs, module Mes Demandes (tickets), Favoris
  READ_INDICATOR = 'READ_INDICATOR',
  // PRED-3233 : bloc « Qualifications des données » du tableau de bord (table des incidents de données et leur détail).
  READ_DATA_QUALIFICATION = 'READ_DATA_QUALIFICATION',
  CREATE_TICKET = 'CREATE_TICKET',
  READ_TICKET = 'READ_TICKET',
  UPDATE_TICKET = 'UPDATE_TICKET',
  DELETE_TICKET = 'DELETE_TICKET',
  // PRED-3233 : lecture par onglet de l'ecran de detail (un code par onglet).
  READ_TICKET_CATALOG = 'READ_TICKET_CATALOG', // onglet Catalogue
  READ_TICKET_FAVORITE = 'READ_TICKET_FAVORITE', // onglet Favoris
  READ_TICKET_BASKET_TYPE = 'READ_TICKET_BASKET_TYPE', // onglet Panier type (ex-onglet reserve aux comptes Predik)
  READ_TICKET_BASKET = 'READ_TICKET_BASKET', // onglet Panier
  READ_TICKET_INFORMATION = 'READ_TICKET_INFORMATION', // onglet Informations
  READ_TICKET_ACTIVITY = 'READ_TICKET_ACTIVITY', // onglet Activites (ex-garde CREATE_OUT_OF_CATALOG, PRED-3172)
  READ_TICKET_GED = 'READ_TICKET_GED', // onglet Documents
  CREATE_FAVORITE = 'CREATE_FAVORITE',
  READ_FAVORITE = 'READ_FAVORITE',
  UPDATE_FAVORITE = 'UPDATE_FAVORITE',
  DELETE_FAVORITE = 'DELETE_FAVORITE',
  // PRED-3233 : lecture par onglet de l'ecran de detail (un code par onglet).
  READ_FAVORITE_CATALOG = 'READ_FAVORITE_CATALOG', // onglet Catalogue
  READ_FAVORITE_INFORMATION = 'READ_FAVORITE_INFORMATION', // onglet Informations
  CREATE_ESTABLISHMENT = 'CREATE_ESTABLISHMENT',
  READ_ESTABLISHMENT = 'READ_ESTABLISHMENT',
  UPDATE_ESTABLISHMENT = 'UPDATE_ESTABLISHMENT',
  DELETE_ESTABLISHMENT = 'DELETE_ESTABLISHMENT',
  // PRED-3130 : visibilité de l'onglet « Acteurs achats » de la fiche établissement.
  ESTABLISHMENT_READ_PURCHASE_ACTORS = 'ESTABLISHMENT_READ_PURCHASE_ACTORS',
  // PRED-3233 : lecture par onglet de l'ecran de detail (un code par onglet).
  READ_ESTABLISHMENT_BUILDINGS = 'READ_ESTABLISHMENT_BUILDINGS', // onglet Batiments
  READ_ESTABLISHMENT_ACTIVITY = 'READ_ESTABLISHMENT_ACTIVITY', // onglet Activites
  READ_ESTABLISHMENT_CONTACT = 'READ_ESTABLISHMENT_CONTACT', // onglet Contact interne
  READ_ESTABLISHMENT_SUPERVISION = 'READ_ESTABLISHMENT_SUPERVISION', // onglet Supervision metier
  READ_ESTABLISHMENT_ANALYTIC_PLAN = 'READ_ESTABLISHMENT_ANALYTIC_PLAN', // onglet Plan analytique
  READ_ESTABLISHMENT_NEEDS = 'READ_ESTABLISHMENT_NEEDS', // onglet Familles achats couvertes
  READ_ESTABLISHMENT_INFORMATION = 'READ_ESTABLISHMENT_INFORMATION', // onglet Informations
  READ_ESTABLISHMENT_GED = 'READ_ESTABLISHMENT_GED', // onglet Documents
  CREATE_INTERNAL_CONTACT = 'CREATE_INTERNAL_CONTACT',
  READ_INTERNAL_CONTACT = 'READ_INTERNAL_CONTACT',
  UPDATE_INTERNAL_CONTACT = 'UPDATE_INTERNAL_CONTACT',
  DELETE_INTERNAL_CONTACT = 'DELETE_INTERNAL_CONTACT',
  // PRED-3233 : lecture par onglet de l'ecran de detail (un code par onglet).
  READ_INTERNAL_CONTACT_PERIMETER = 'READ_INTERNAL_CONTACT_PERIMETER', // onglet Perimetre e-Shop360
  READ_INTERNAL_CONTACT_ROLES = 'READ_INTERNAL_CONTACT_ROLES', // onglet Roles
  READ_INTERNAL_CONTACT_INFORMATION = 'READ_INTERNAL_CONTACT_INFORMATION', // onglet Informations
  CREATE_BASKET_TYPE = 'CREATE_BASKET_TYPE',
  READ_BASKET_TYPE = 'READ_BASKET_TYPE',
  UPDATE_BASKET_TYPE = 'UPDATE_BASKET_TYPE',
  DELETE_BASKET_TYPE = 'DELETE_BASKET_TYPE',
  // PRED-3233 : lecture par onglet de l'ecran de detail (un code par onglet).
  READ_BASKET_TYPE_CATALOG = 'READ_BASKET_TYPE_CATALOG', // onglet Catalogue
  READ_BASKET_TYPE_INTERNAL_CONTACT = 'READ_BASKET_TYPE_INTERNAL_CONTACT', // onglet Affectation contact interne
  READ_BASKET_TYPE_INFORMATION = 'READ_BASKET_TYPE_INFORMATION', // onglet Informations
  CREATE_TVA = 'CREATE_TVA',
  READ_TVA = 'READ_TVA',
  UPDATE_TVA = 'UPDATE_TVA',
  DELETE_TVA = 'DELETE_TVA',
  READ_TVA_INFORMATION = 'READ_TVA_INFORMATION', // PRED-3233 : onglet Informations
  // PRED-3233 : page « Administration tenant » (settings/customerGroup), ex-réservée aux comptes Predik.
  CREATE_CUSTOMER_GROUP = 'CREATE_CUSTOMER_GROUP',
  READ_CUSTOMER_GROUP = 'READ_CUSTOMER_GROUP',
  UPDATE_CUSTOMER_GROUP = 'UPDATE_CUSTOMER_GROUP',
  DELETE_CUSTOMER_GROUP = 'DELETE_CUSTOMER_GROUP',
  READ_CUSTOMER_GROUP_INFORMATION = 'READ_CUSTOMER_GROUP_INFORMATION', // onglet Informations
  READ_CUSTOMER_GROUP_VALIDATION = 'READ_CUSTOMER_GROUP_VALIDATION', // onglet Autorisation de dépenses
  READ_CUSTOMER_GROUP_ACCOUNTING = 'READ_CUSTOMER_GROUP_ACCOUNTING', // onglet Données comptables
  READ_CUSTOMER_GROUP_ROLES = 'READ_CUSTOMER_GROUP_ROLES', // onglet Rôles
  READ_CUSTOMER_GROUP_GED = 'READ_CUSTOMER_GROUP_GED', // onglet GED
  READ_CUSTOMER_GROUP_SUPERVISION = 'READ_CUSTOMER_GROUP_SUPERVISION', // onglet Supervision métier par défaut
  READ_CUSTOMER_GROUP_PURCHASE_ACTORS = 'READ_CUSTOMER_GROUP_PURCHASE_ACTORS', // onglet Acteurs achat par défaut (PRED-3139)
  READ_CUSTOMER_GROUP_DOCUMENTS = 'READ_CUSTOMER_GROUP_DOCUMENTS', // onglet Pièces jointes processus
  // PRED-3233 : menu « Administration générique » (Paramétrage Client), ex-réservé aux comptes Predik.
  READ_REFERENCE_WITHOUT_GENERIC = 'READ_REFERENCE_WITHOUT_GENERIC', // écran « Références sans générique »
  UPDATE_REFERENCE_WITHOUT_GENERIC = 'UPDATE_REFERENCE_WITHOUT_GENERIC', // affecter un générique
  READ_REFERENCE_WITHOUT_GENERIC_PRODUCT = 'READ_REFERENCE_WITHOUT_GENERIC_PRODUCT', // onglet Articles
  READ_REFERENCE_WITHOUT_GENERIC_PRESTATION = 'READ_REFERENCE_WITHOUT_GENERIC_PRESTATION', // onglet Prestations
  READ_REFERENCE_WITHOUT_GENERIC_EQUIPMENT = 'READ_REFERENCE_WITHOUT_GENERIC_EQUIPMENT', // onglet Equipements
  READ_REFERENCE_TO_VALIDATE = 'READ_REFERENCE_TO_VALIDATE', // écran « Références à valider »
  UPDATE_REFERENCE_TO_VALIDATE = 'UPDATE_REFERENCE_TO_VALIDATE', // valider / modifier l'affectation générique
  READ_REFERENCE_TO_VALIDATE_PRODUCT = 'READ_REFERENCE_TO_VALIDATE_PRODUCT', // onglet Articles
  READ_REFERENCE_TO_VALIDATE_PRESTATION = 'READ_REFERENCE_TO_VALIDATE_PRESTATION', // onglet Prestations
  CREATE_BUILDING = 'CREATE_BUILDING',
  READ_BUILDING = 'READ_BUILDING',
  UPDATE_BUILDING = 'UPDATE_BUILDING',
  DELETE_BUILDING = 'DELETE_BUILDING',
  // PRED-3233 : lecture par onglet de l'ecran de detail (un code par onglet).
  READ_BUILDING_ROOM = 'READ_BUILDING_ROOM', // onglet Salles
  READ_BUILDING_INFORMATION = 'READ_BUILDING_INFORMATION', // onglet Informations
  READ_BUILDING_GED = 'READ_BUILDING_GED', // onglet Documents
  CREATE_EQUIPMENT = 'CREATE_EQUIPMENT',
  READ_EQUIPMENT = 'READ_EQUIPMENT',
  UPDATE_EQUIPMENT = 'UPDATE_EQUIPMENT',
  DELETE_EQUIPMENT = 'DELETE_EQUIPMENT',
  // PRED-3233 : lecture par onglet de l'ecran de detail (un code par onglet).
  READ_EQUIPMENT_SERVICE_BOOK = 'READ_EQUIPMENT_SERVICE_BOOK', // onglet Carnet d'entretien
  READ_EQUIPMENT_INFORMATION = 'READ_EQUIPMENT_INFORMATION', // onglet Informations
  READ_EQUIPMENT_GED = 'READ_EQUIPMENT_GED', // onglet Documents
  CREATE_ENERGY_ID = 'CREATE_ENERGY_ID',
  READ_ENERGY_ID = 'READ_ENERGY_ID',
  UPDATE_ENERGY_ID = 'UPDATE_ENERGY_ID',
  DELETE_ENERGY_ID = 'DELETE_ENERGY_ID',
  CREATE_ORDER = 'CREATE_ORDER',
  READ_ORDER = 'READ_ORDER',
  UPDATE_ORDER = 'UPDATE_ORDER',
  DELETE_ORDER = 'DELETE_ORDER',
  READ_ORDER_BASKET = 'READ_ORDER_BASKET',
  READ_ORDER_ACTIVITY = 'READ_ORDER_ACTIVITY',
  READ_ORDER_ANALYTICAL_AXIS = 'READ_ORDER_ANALYTICAL_AXIS',
  READ_ORDER_SUMMARY = 'READ_ORDER_SUMMARY',
  READ_ORDER_INFORMATION = 'READ_ORDER_INFORMATION', // onglet Informations (commande et commandes own)
  READ_ORDER_GED = 'READ_ORDER_GED', // onglet Documents
  // PRED-3128 : permissions dédiées aux commandes de régularisation
  CREATE_ORDER_REGU = 'CREATE_ORDER_REGU',
  READ_ORDER_REGU = 'READ_ORDER_REGU',
  UPDATE_ORDER_REGU = 'UPDATE_ORDER_REGU',
  DELETE_ORDER_REGU = 'DELETE_ORDER_REGU',
  // PRED-3233 : onglets de la commande de regularisation (jeu distinct de la commande, meme ecran).
  READ_ORDER_REGU_INFORMATION = 'READ_ORDER_REGU_INFORMATION', // onglet Informations
  READ_ORDER_REGU_BASKET = 'READ_ORDER_REGU_BASKET', // onglet Panier
  READ_ORDER_REGU_ACTIVITY = 'READ_ORDER_REGU_ACTIVITY', // onglet Repartition par activite
  READ_ORDER_REGU_ANALYTICAL_AXIS = 'READ_ORDER_REGU_ANALYTICAL_AXIS', // onglet Affectations analytiques
  READ_ORDER_REGU_SUMMARY = 'READ_ORDER_REGU_SUMMARY', // onglet Recapitulatif
  READ_ORDER_REGU_GED = 'READ_ORDER_REGU_GED', // onglet Documents
  CREATE_QUOTE = 'CREATE_QUOTE',
  READ_QUOTE = 'READ_QUOTE',
  UPDATE_QUOTE = 'UPDATE_QUOTE',
  DELETE_QUOTE = 'DELETE_QUOTE',
  READ_QUOTE_INFORMATION = 'READ_QUOTE_INFORMATION', // PRED-3233 : onglet Informations
  READ_QUOTE_GED = 'READ_QUOTE_GED', // PRED-3233 : onglet Documents
  CREATE_RECEPTION = 'CREATE_RECEPTION',
  READ_RECEPTION = 'READ_RECEPTION',
  UPDATE_RECEPTION = 'UPDATE_RECEPTION',
  DELETE_RECEPTION = 'DELETE_RECEPTION',
  // PRED-3233 : lecture par onglet de l'ecran de detail (un code par onglet).
  READ_RECEPTION_LINES = 'READ_RECEPTION_LINES', // onglet Lignes de reception
  READ_RECEPTION_INFORMATION = 'READ_RECEPTION_INFORMATION', // onglet Informations
  READ_RECEPTION_GED = 'READ_RECEPTION_GED', // onglet Documents
  CREATE_INTERVENTION = 'CREATE_INTERVENTION',
  READ_INTERVENTION = 'READ_INTERVENTION',
  UPDATE_INTERVENTION = 'UPDATE_INTERVENTION',
  DELETE_INTERVENTION = 'DELETE_INTERVENTION',
  // PRED-3233 : onglets de l'ecran « Gérer une intervention externe » (listes), un code par onglet.
  READ_INTERVENTION_CORRECTIVE_LIST = 'READ_INTERVENTION_CORRECTIVE_LIST', // onglet Interventions externes sur devis
  READ_INTERVENTION_CORRECTIVE_PLANNING = 'READ_INTERVENTION_CORRECTIVE_PLANNING', // onglet Planning des interventions externes sur devis
  READ_INTERVENTION_PREVENTIVE_LIST = 'READ_INTERVENTION_PREVENTIVE_LIST', // onglet Interventions externes sous contrat
  READ_INTERVENTION_PREVENTIVE_PLANIFICATION = 'READ_INTERVENTION_PREVENTIVE_PLANIFICATION', // onglet Planification des interventions externes sous contrat
  CREATE_BILL = 'CREATE_BILL',
  READ_BILL = 'READ_BILL',
  UPDATE_BILL = 'UPDATE_BILL',
  DELETE_BILL = 'DELETE_BILL',
  HARD_DELETE_BILL = 'HARD_DELETE_BILL', // PRED-3257 : suppression définitive (Predik + DocuWare), ex-réservée aux comptes Predik
  // PRED-3233 : lecture par onglet de l'ecran de detail (un code par onglet).
  READ_BILL_APPROVAL = 'READ_BILL_APPROVAL', // onglet Validation depense
  READ_BILL_CATALOG = 'READ_BILL_CATALOG', // onglet Catalogue
  READ_BILL_SUMMARY = 'READ_BILL_SUMMARY', // onglet Recapitulatif
  READ_BILL_ANALYTICAL_AXIS = 'READ_BILL_ANALYTICAL_AXIS', // onglet Traitement comptable
  READ_BILL_INFORMATION = 'READ_BILL_INFORMATION', // onglet Informations
  READ_BILL_GED = 'READ_BILL_GED', // onglet Documents
  // PRED-3233 : écran « Export comptable des écritures », découplé des permissions Facture.
  READ_ACCOUNTING_EXPORT = 'READ_ACCOUNTING_EXPORT', // accès à l'écran, téléchargement des exports
  UPDATE_ACCOUNTING_EXPORT = 'UPDATE_ACCOUNTING_EXPORT', // générer un export, export non conforme, exporter une facture
  // PRED-3233 : onglets de l'ecran « Export comptable des écritures », un code par onglet.
  READ_ACCOUNTING_EXPORT_BILLS = 'READ_ACCOUNTING_EXPORT_BILLS', // onglet Factures à exporter
  READ_ACCOUNTING_EXPORT_CONTROL = 'READ_ACCOUNTING_EXPORT_CONTROL', // onglet États de contrôle
  CREATE_SUPPLIER = 'CREATE_SUPPLIER',
  READ_SUPPLIER = 'READ_SUPPLIER',
  UPDATE_SUPPLIER = 'UPDATE_SUPPLIER',
  DELETE_SUPPLIER = 'DELETE_SUPPLIER',
  // PRED-3233 : lecture par onglet de l'ecran de detail (un code par onglet).
  READ_SUPPLIER_CONTACT = 'READ_SUPPLIER_CONTACT', // onglet Contacts fournisseurs
  READ_SUPPLIER_CLIENT_NUMBER = 'READ_SUPPLIER_CLIENT_NUMBER', // onglet N° client
  READ_SUPPLIER_INFORMATION = 'READ_SUPPLIER_INFORMATION', // onglet Informations
  READ_SUPPLIER_GED = 'READ_SUPPLIER_GED', // onglet Documents
  READ_SUPPLIER_API = 'READ_SUPPLIER_API', // onglet API (ex-onglet reserve aux comptes Predik)
  CREATE_PRODUCT = 'CREATE_PRODUCT',
  READ_PRODUCT = 'READ_PRODUCT',
  UPDATE_PRODUCT = 'UPDATE_PRODUCT',
  DELETE_PRODUCT = 'DELETE_PRODUCT',
  CREATE_SERVICE = 'CREATE_SERVICE',
  READ_SERVICE = 'READ_SERVICE',
  UPDATE_SERVICE = 'UPDATE_SERVICE',
  DELETE_SERVICE = 'DELETE_SERVICE',
  CREATE_CONTRACT = 'CREATE_CONTRACT',
  READ_CONTRACT = 'READ_CONTRACT',
  UPDATE_CONTRACT = 'UPDATE_CONTRACT',
  DELETE_CONTRACT = 'DELETE_CONTRACT',
  // PRED-3233 : lecture par onglet de l'ecran de detail (un code par onglet).
  READ_CONTRACT_PERIMETER = 'READ_CONTRACT_PERIMETER', // onglet Perimetre
  READ_CONTRACT_CGA = 'READ_CONTRACT_CGA', // onglet CGA
  READ_CONTRACT_CATALOG = 'READ_CONTRACT_CATALOG', // onglet Catalogue fournisseur
  READ_CONTRACT_BASKET = 'READ_CONTRACT_BASKET', // onglet Panier contrat
  READ_CONTRACT_INFORMATION = 'READ_CONTRACT_INFORMATION', // onglet Informations
  CREATE_LITIGATION = 'CREATE_LITIGATION',
  READ_LITIGATION = 'READ_LITIGATION',
  UPDATE_LITIGATION = 'UPDATE_LITIGATION',
  DELETE_LITIGATION = 'DELETE_LITIGATION',
  // PRED-3233 : lecture par onglet de l'ecran de detail (un code par onglet).
  READ_LITIGATION_ACTIONS = 'READ_LITIGATION_ACTIONS', // onglet Actions
  READ_LITIGATION_INFORMATION = 'READ_LITIGATION_INFORMATION', // onglet Informations
  READ_LITIGATION_GED = 'READ_LITIGATION_GED', // onglet Documents
  CREATE_HOTTOPIC = 'CREATE_HOTTOPIC',
  // PRED-3128 : actualités (hot topics) du tenant — le /list reste ouvert (carrousel ticket-home)
  READ_HOTTOPIC = 'READ_HOTTOPIC',
  UPDATE_HOTTOPIC = 'UPDATE_HOTTOPIC',
  DELETE_HOTTOPIC = 'DELETE_HOTTOPIC',
  // PRED-3233 : lecture par onglet de l'ecran de detail (un code par onglet).
  READ_HOTTOPIC_CONTRACT = 'READ_HOTTOPIC_CONTRACT', // onglet Contrat
  READ_HOTTOPIC_INFORMATION = 'READ_HOTTOPIC_INFORMATION', // onglet General (Informations)
  MANAGE_SUPPLIER_API_KEY = 'MANAGE_SUPPLIER_API_KEY',
  // PRED-3172 : Le déclarant ne doit pas pouvoir visualiser l'onglet Activité dans eShop
  CREATE_OUT_OF_CATALOG = 'CREATE_OUT_OF_CATALOG',
  READ_OUT_OF_CATALOG = 'READ_OUT_OF_CATALOG',
  UPDATE_OUT_OF_CATALOG = 'UPDATE_OUT_OF_CATALOG',
  DELETE_OUT_OF_CATALOG = 'DELETE_OUT_OF_CATALOG',
}

/**
 * Libellés humains des permissions, affichés à l'utilisateur quand un droit lui manque
 * (snackbar du PermissionGuard, tooltip de la directive permissionBlock).
 * Les libellés de référence vivent dans la collection `permissions` (DB core) ;
 * cette map n'est qu'un affichage de secours côté front — fallback sur le code si absent.
 */
export const PERMISSION_LABELS: Partial<Record<ENUM_PERMISSIONS, string>> = {
  [ENUM_PERMISSIONS.READ_TICKET]: 'Lire une demande',
  [ENUM_PERMISSIONS.CREATE_TICKET]: 'Créer une demande',
  [ENUM_PERMISSIONS.UPDATE_TICKET]: 'Modifier une demande',
  [ENUM_PERMISSIONS.DELETE_TICKET]: 'Supprimer une demande',
  [ENUM_PERMISSIONS.READ_INDICATOR]: 'Lire les indicateurs',
  [ENUM_PERMISSIONS.READ_FAVORITE]: 'Lire les favoris',
  [ENUM_PERMISSIONS.CREATE_FAVORITE]: 'Créer un favori',
  [ENUM_PERMISSIONS.UPDATE_FAVORITE]: 'Modifier un favori',
  [ENUM_PERMISSIONS.DELETE_FAVORITE]: 'Supprimer un favori',
  [ENUM_PERMISSIONS.CREATE_QUOTE]: 'Créer une demande de devis',
  [ENUM_PERMISSIONS.READ_ORDER]: 'Lire une commande',
  [ENUM_PERMISSIONS.CREATE_ORDER]: 'Créer une commande',
  [ENUM_PERMISSIONS.UPDATE_ORDER]: 'Modifier une commande',
  [ENUM_PERMISSIONS.DELETE_ORDER]: 'Supprimer une commande',
  [ENUM_PERMISSIONS.READ_ORDER_REGU]: 'Lire une commande de régularisation',
  [ENUM_PERMISSIONS.READ_HOTTOPIC]: 'Lire une actualité',
  [ENUM_PERMISSIONS.CREATE_HOTTOPIC]: 'Créer une actualité',
  [ENUM_PERMISSIONS.UPDATE_HOTTOPIC]: 'Modifier une actualité',
  [ENUM_PERMISSIONS.DELETE_HOTTOPIC]: 'Supprimer une actualité',
  [ENUM_PERMISSIONS.CREATE_ORDER_REGU]: 'Créer une commande de régularisation',
  [ENUM_PERMISSIONS.UPDATE_ORDER_REGU]: 'Modifier une commande de régularisation',
  [ENUM_PERMISSIONS.DELETE_ORDER_REGU]: 'Supprimer une commande de régularisation',
  [ENUM_PERMISSIONS.CREATE_INTERNAL_CONTACT]: 'Créer un contact interne',
  [ENUM_PERMISSIONS.READ_INTERNAL_CONTACT]: 'Lire un contact interne',
  [ENUM_PERMISSIONS.UPDATE_INTERNAL_CONTACT]: 'Modifier un contact interne',
  [ENUM_PERMISSIONS.DELETE_INTERNAL_CONTACT]: 'Supprimer un contact interne',
  [ENUM_PERMISSIONS.READ_BILL]: 'Lire une facture',
  [ENUM_PERMISSIONS.CREATE_BILL]: 'Créer une facture',
  [ENUM_PERMISSIONS.UPDATE_BILL]: 'Modifier une facture',
  [ENUM_PERMISSIONS.DELETE_BILL]: 'Supprimer une facture',
  [ENUM_PERMISSIONS.HARD_DELETE_BILL]: 'Supprimer définitivement une facture (Predik et DocuWare)',
  [ENUM_PERMISSIONS.READ_QUOTE]: 'Lire une demande de devis',
  [ENUM_PERMISSIONS.UPDATE_QUOTE]: 'Modifier une demande de devis',
  [ENUM_PERMISSIONS.DELETE_QUOTE]: 'Supprimer une demande de devis',
  [ENUM_PERMISSIONS.READ_SUPPLIER]: 'Lire un fournisseur',
  [ENUM_PERMISSIONS.CREATE_SUPPLIER]: 'Créer un fournisseur',
  [ENUM_PERMISSIONS.UPDATE_SUPPLIER]: 'Modifier un fournisseur',
  [ENUM_PERMISSIONS.DELETE_SUPPLIER]: 'Supprimer un fournisseur',
  [ENUM_PERMISSIONS.ESTABLISHMENT_READ_PURCHASE_ACTORS]: "Lire les acteurs achats d'un établissement",
  [ENUM_PERMISSIONS.READ_OUT_OF_CATALOG]: 'Voir les articles hors catalogue',
  [ENUM_PERMISSIONS.CREATE_OUT_OF_CATALOG]: 'Créer un article hors catalogue',
  [ENUM_PERMISSIONS.UPDATE_OUT_OF_CATALOG]: 'Mettre à jour un article hors catalogue',
  [ENUM_PERMISSIONS.DELETE_OUT_OF_CATALOG]: 'Supprimer des articles hors catalogue',
  // PRED-3233 : libellés des lectures par onglet
  [ENUM_PERMISSIONS.READ_ORDER_BASKET]: 'Lire le panier d’une commande',
  [ENUM_PERMISSIONS.READ_ORDER_ACTIVITY]: 'Lire la répartition par activité d’une commande',
  [ENUM_PERMISSIONS.READ_ORDER_ANALYTICAL_AXIS]: 'Lire les affectations analytiques d’une commande',
  [ENUM_PERMISSIONS.READ_ORDER_SUMMARY]: 'Lire le récapitulatif d’une commande',
  [ENUM_PERMISSIONS.READ_TICKET_CATALOG]: 'Lire le catalogue d’une demande',
  [ENUM_PERMISSIONS.READ_TICKET_FAVORITE]: 'Lire les favoris d’une demande',
  [ENUM_PERMISSIONS.READ_TICKET_BASKET_TYPE]: 'Lire les paniers types d’une demande',
  [ENUM_PERMISSIONS.READ_TICKET_BASKET]: 'Lire le panier d’une demande',
  [ENUM_PERMISSIONS.READ_FAVORITE_CATALOG]: 'Lire le catalogue d’un favori',
  [ENUM_PERMISSIONS.READ_ESTABLISHMENT_BUILDINGS]: 'Lire les bâtiments d’un établissement',
  [ENUM_PERMISSIONS.READ_ESTABLISHMENT_ACTIVITY]: 'Lire les activités d’un établissement',
  [ENUM_PERMISSIONS.READ_ESTABLISHMENT_CONTACT]: 'Lire les contacts internes d’un établissement',
  [ENUM_PERMISSIONS.READ_ESTABLISHMENT_SUPERVISION]: 'Lire la supervision métier d’un établissement',
  [ENUM_PERMISSIONS.READ_ESTABLISHMENT_ANALYTIC_PLAN]: 'Lire le plan analytique d’un établissement',
  [ENUM_PERMISSIONS.READ_ESTABLISHMENT_NEEDS]: 'Lire les familles achats couvertes d’un établissement',
  [ENUM_PERMISSIONS.READ_INTERNAL_CONTACT_PERIMETER]: 'Lire le périmètre e-Shop360 d’un contact interne',
  [ENUM_PERMISSIONS.READ_INTERNAL_CONTACT_ROLES]: 'Lire les rôles d’un contact interne',
  [ENUM_PERMISSIONS.READ_BASKET_TYPE_CATALOG]: 'Lire le catalogue d’un panier type',
  [ENUM_PERMISSIONS.READ_BASKET_TYPE_INTERNAL_CONTACT]: 'Lire l’affectation contact interne d’un panier type',
  [ENUM_PERMISSIONS.READ_BUILDING_ROOM]: 'Lire les salles d’un bâtiment',
  [ENUM_PERMISSIONS.READ_EQUIPMENT_SERVICE_BOOK]: 'Lire le carnet d’entretien d’un équipement',
  [ENUM_PERMISSIONS.READ_RECEPTION_LINES]: 'Lire les lignes d’une réception',
  [ENUM_PERMISSIONS.READ_BILL_APPROVAL]: 'Lire la validation de dépense d’une facture',
  [ENUM_PERMISSIONS.READ_BILL_CATALOG]: 'Lire le catalogue d’une facture',
  [ENUM_PERMISSIONS.READ_BILL_SUMMARY]: 'Lire le récapitulatif d’une facture',
  [ENUM_PERMISSIONS.READ_BILL_ANALYTICAL_AXIS]: 'Lire le traitement comptable d’une facture',
  [ENUM_PERMISSIONS.READ_ACCOUNTING_EXPORT]: 'Lire l’export comptable des écritures',
  [ENUM_PERMISSIONS.UPDATE_ACCOUNTING_EXPORT]: 'Modifier l’export comptable des écritures',
  // PRED-3233 : onglets Informations / Documents (et Activités de la demande)
  [ENUM_PERMISSIONS.READ_TICKET_INFORMATION]: 'Lire les informations d’une demande',
  [ENUM_PERMISSIONS.READ_TICKET_ACTIVITY]: 'Lire les activités d’une demande',
  [ENUM_PERMISSIONS.READ_TICKET_GED]: 'Lire les documents d’une demande',
  [ENUM_PERMISSIONS.READ_FAVORITE_INFORMATION]: 'Lire les informations d’un favori',
  [ENUM_PERMISSIONS.READ_ESTABLISHMENT_INFORMATION]: 'Lire les informations d’un établissement',
  [ENUM_PERMISSIONS.READ_ESTABLISHMENT_GED]: 'Lire les documents d’un établissement',
  [ENUM_PERMISSIONS.READ_INTERNAL_CONTACT_INFORMATION]: 'Lire les informations d’un contact interne',
  [ENUM_PERMISSIONS.READ_BASKET_TYPE_INFORMATION]: 'Lire les informations d’un panier type',
  [ENUM_PERMISSIONS.READ_TVA_INFORMATION]: 'Lire les informations d’une TVA',
  [ENUM_PERMISSIONS.CREATE_CUSTOMER_GROUP]: 'Créer dans l’administration tenant',
  [ENUM_PERMISSIONS.READ_CUSTOMER_GROUP]: 'Lire l’administration tenant',
  [ENUM_PERMISSIONS.UPDATE_CUSTOMER_GROUP]: 'Modifier l’administration tenant',
  [ENUM_PERMISSIONS.DELETE_CUSTOMER_GROUP]: 'Supprimer dans l’administration tenant',
  [ENUM_PERMISSIONS.READ_CUSTOMER_GROUP_INFORMATION]: 'Lire les informations de l’administration tenant',
  [ENUM_PERMISSIONS.READ_CUSTOMER_GROUP_VALIDATION]: 'Lire les autorisations de dépenses',
  [ENUM_PERMISSIONS.READ_CUSTOMER_GROUP_ACCOUNTING]: 'Lire les données comptables',
  [ENUM_PERMISSIONS.READ_CUSTOMER_GROUP_ROLES]: 'Lire les rôles',
  [ENUM_PERMISSIONS.READ_CUSTOMER_GROUP_GED]: 'Lire la configuration GED',
  [ENUM_PERMISSIONS.READ_CUSTOMER_GROUP_SUPERVISION]: 'Lire la supervision métier par défaut',
  [ENUM_PERMISSIONS.READ_CUSTOMER_GROUP_PURCHASE_ACTORS]: 'Lire les acteurs achat par défaut',
  [ENUM_PERMISSIONS.READ_CUSTOMER_GROUP_DOCUMENTS]: 'Lire les pièces jointes processus',
  [ENUM_PERMISSIONS.READ_REFERENCE_WITHOUT_GENERIC]: 'Lire les références sans générique',
  [ENUM_PERMISSIONS.UPDATE_REFERENCE_WITHOUT_GENERIC]: 'Affecter un générique aux références sans générique',
  [ENUM_PERMISSIONS.READ_REFERENCE_WITHOUT_GENERIC_PRODUCT]: 'Lire les articles sans générique',
  [ENUM_PERMISSIONS.READ_REFERENCE_WITHOUT_GENERIC_PRESTATION]: 'Lire les prestations sans générique',
  [ENUM_PERMISSIONS.READ_REFERENCE_WITHOUT_GENERIC_EQUIPMENT]: 'Lire les équipements sans générique',
  [ENUM_PERMISSIONS.READ_REFERENCE_TO_VALIDATE]: 'Lire les références à valider',
  [ENUM_PERMISSIONS.UPDATE_REFERENCE_TO_VALIDATE]:
    'Valider ou modifier l’affectation générique des références à valider',
  [ENUM_PERMISSIONS.READ_REFERENCE_TO_VALIDATE_PRODUCT]: 'Lire les articles à valider',
  [ENUM_PERMISSIONS.READ_REFERENCE_TO_VALIDATE_PRESTATION]: 'Lire les prestations à valider',
  [ENUM_PERMISSIONS.READ_BUILDING_INFORMATION]: 'Lire les informations d’un bâtiment',
  [ENUM_PERMISSIONS.READ_BUILDING_GED]: 'Lire les documents d’un bâtiment',
  [ENUM_PERMISSIONS.READ_EQUIPMENT_INFORMATION]: 'Lire les informations d’un équipement',
  [ENUM_PERMISSIONS.READ_EQUIPMENT_GED]: 'Lire les documents d’un équipement',
  [ENUM_PERMISSIONS.READ_ORDER_INFORMATION]: 'Lire les informations d’une commande',
  [ENUM_PERMISSIONS.READ_ORDER_GED]: 'Lire les documents d’une commande',
  [ENUM_PERMISSIONS.READ_ORDER_REGU_INFORMATION]: 'Lire les informations d’une commande de régularisation',
  [ENUM_PERMISSIONS.READ_ORDER_REGU_BASKET]: 'Lire le panier d’une commande de régularisation',
  [ENUM_PERMISSIONS.READ_ORDER_REGU_ACTIVITY]: 'Lire l’activité d’une commande de régularisation',
  [ENUM_PERMISSIONS.READ_ORDER_REGU_ANALYTICAL_AXIS]:
    'Lire les affectations analytiques d’une commande de régularisation',
  [ENUM_PERMISSIONS.READ_ORDER_REGU_SUMMARY]: 'Lire le récapitulatif d’une commande de régularisation',
  [ENUM_PERMISSIONS.READ_ORDER_REGU_GED]: 'Lire les documents d’une commande de régularisation',
  [ENUM_PERMISSIONS.READ_QUOTE_INFORMATION]: 'Lire les informations d’une demande de devis',
  [ENUM_PERMISSIONS.READ_QUOTE_GED]: 'Lire les documents d’une demande de devis',
  [ENUM_PERMISSIONS.READ_RECEPTION_INFORMATION]: 'Lire les informations d’une réception',
  [ENUM_PERMISSIONS.READ_RECEPTION_GED]: 'Lire les documents d’une réception',
  [ENUM_PERMISSIONS.READ_BILL_INFORMATION]: 'Lire les informations d’une facture',
  [ENUM_PERMISSIONS.READ_BILL_GED]: 'Lire les documents d’une facture',
  [ENUM_PERMISSIONS.READ_SUPPLIER_INFORMATION]: 'Lire les informations d’un fournisseur',
  [ENUM_PERMISSIONS.READ_SUPPLIER_GED]: 'Lire les documents d’un fournisseur',
  [ENUM_PERMISSIONS.READ_CONTRACT_INFORMATION]: 'Lire les informations d’un contrat',
  [ENUM_PERMISSIONS.READ_LITIGATION_INFORMATION]: 'Lire les informations d’un litige',
  [ENUM_PERMISSIONS.READ_LITIGATION_GED]: 'Lire les documents d’un litige',
  [ENUM_PERMISSIONS.READ_HOTTOPIC_INFORMATION]: 'Lire les informations d’une actualité',
  [ENUM_PERMISSIONS.READ_SUPPLIER_CONTACT]: 'Lire les contacts d’un fournisseur',
  [ENUM_PERMISSIONS.READ_SUPPLIER_CLIENT_NUMBER]: 'Lire les n° client d’un fournisseur',
  [ENUM_PERMISSIONS.READ_SUPPLIER_API]: 'Lire les clés API d’un fournisseur',
  [ENUM_PERMISSIONS.MANAGE_SUPPLIER_API_KEY]: 'Gérer les clés API d’un fournisseur',
  [ENUM_PERMISSIONS.READ_CONTRACT]: 'Lire un contrat',
  [ENUM_PERMISSIONS.READ_CONTRACT_PERIMETER]: 'Lire le périmètre d’un contrat',
  [ENUM_PERMISSIONS.READ_CONTRACT_CGA]: 'Lire les CGA d’un contrat',
  [ENUM_PERMISSIONS.READ_CONTRACT_CATALOG]: 'Lire le catalogue fournisseur d’un contrat',
  [ENUM_PERMISSIONS.READ_CONTRACT_BASKET]: 'Lire le panier contrat d’un contrat',
  [ENUM_PERMISSIONS.READ_LITIGATION]: 'Lire un litige',
  [ENUM_PERMISSIONS.READ_LITIGATION_ACTIONS]: 'Lire les actions d’un litige',
  [ENUM_PERMISSIONS.READ_HOTTOPIC_CONTRACT]: 'Lire le contrat d’une actualité',
  [ENUM_PERMISSIONS.READ_RECEPTION]: 'Lire une réception',
  [ENUM_PERMISSIONS.READ_BUILDING]: 'Lire un bâtiment',
  [ENUM_PERMISSIONS.READ_EQUIPMENT]: 'Lire un équipement',
  [ENUM_PERMISSIONS.READ_BASKET_TYPE]: 'Lire un panier type',
  [ENUM_PERMISSIONS.READ_ESTABLISHMENT]: 'Lire un établissement',
  // PRED-3233 (retour recette 14/09) : qualification des données, onglets interventions externes et export comptable
  [ENUM_PERMISSIONS.READ_DATA_QUALIFICATION]: 'Lire la qualification des données du tableau de bord',
  [ENUM_PERMISSIONS.READ_INTERVENTION_CORRECTIVE_LIST]: 'Lire les interventions externes sur devis',
  [ENUM_PERMISSIONS.READ_INTERVENTION_CORRECTIVE_PLANNING]: 'Lire le planning des interventions externes sur devis',
  [ENUM_PERMISSIONS.READ_INTERVENTION_PREVENTIVE_LIST]: 'Lire les interventions externes sous contrat',
  [ENUM_PERMISSIONS.READ_INTERVENTION_PREVENTIVE_PLANIFICATION]:
    'Lire la planification des interventions externes sous contrat',
  [ENUM_PERMISSIONS.READ_ACCOUNTING_EXPORT_BILLS]: 'Lire les factures à exporter',
  [ENUM_PERMISSIONS.READ_ACCOUNTING_EXPORT_CONTROL]: 'Lire les états de contrôle de l’export comptable',
};
